export default __webpack_public_path__ + "static/unsolvedCase-962dd809f515322ad12e7f9c9279bff3.jpg";